import React from 'react';
import {BiBold,BiItalic,BiUnderline,BiStrikethrough} from "react-icons/bi"
class TextEditor extends React.Component {
    
    constructor(props) {
        super(props);
        this.onBoldFontClicked=this.onBoldFontClicked.bind(this);
        this.onStrikeClicked=this.onStrikeClicked.bind(this);
        this.onUnderLineClicked=this.onUnderLineClicked.bind(this);
        this.onItalicClicked=this.onItalicClicked.bind(this);
    }

    onBoldFontClicked(){
        const {props}=this.props;
        var canvas =props.designer.drawingCanvas;
        var activeObject = canvas.getActiveObject();
        if (activeObject) {
            activeObject.fontWeight = (activeObject.fontWeight === 'bold' ? '' : 'bold');	
            canvas.renderAll();
         }
    }

    onItalicClicked(){
        const {props}=this.props;
        var canvas =props.designer.drawingCanvas;
        var activeObject = canvas.getActiveObject();
         if (activeObject) {
            activeObject.fontStyle = (activeObject.fontStyle === 'italic' ? '' : 'italic');
            canvas.renderAll();
		 	//activeObject.sendToBack();
		 }
    }

    onStrikeClicked(){
        const {props}=this.props;
        var canvas =props.designer.drawingCanvas;
        var activeObject = canvas.getActiveObject();
         if (activeObject) {
            activeObject.linethrough = (activeObject.linethrough === true ? false : true);
            canvas.renderAll();
         }

    }

    onUnderLineClicked(){
        const {props}=this.props;
        var canvas =props.designer.drawingCanvas;
        var activeObject = canvas.getActiveObject();
         if (activeObject) {
            activeObject.underline = (activeObject.underline === true ? false : true);
            canvas.renderAll();
		 }

    
    }

    onFontColorChange(color){
        const {props}=this.props;
        var canvas =props.designer.drawingCanvas;
        var activeObject = canvas.getActiveObject();
        if (activeObject && activeObject.type === 'text') {
            activeObject.fill = color;
        }
        canvas.renderAll();
    }

    onFontBorderChange(color){

        const {props}=this.props;
        var canvas =props.designer.drawingCanvas;
        var activeObject = canvas.getActiveObject();
        if (activeObject && activeObject.type === 'text') {
            activeObject.stroke = color;
            
        }
        canvas.renderAll();
    }


    render() {
        return (
        <div id="textEditorButton" style={{visibility:'hidden'}}>										      
        <button  title="Bold Font" onClick={this.onBoldFontClicked}><span><BiBold size={35} color='grey'/></span></button>
        <button title="Strike Word" onClick={this.onStrikeClicked}><span><BiStrikethrough size={35} color='grey'/></span></button>
        <button  onClick={this.onUnderLineClicked} title="Under Line"><span><BiUnderline size={35} color='grey'/></span></button>
        <input id="fontColor" defaultValue="#000000" onChange={(e)=>{this.onFontColorChange(e.target.value)}} type="color"/>
        <input id="borderColor"type="color" defaultValue="#000000" onChange={(e)=>{this.onFontBorderChange(e.target.value)}}/>
    </div> 
     );
    }
}
 
export default TextEditor;
// const ImageEditor = ({onZoomClicked,props}) => {
//     console.error(props);
//     return (
//         <div id="imageeditor"> 
//     <div id="imageEditorButton"  style={{zIndex:"1"}}>										      
//     <button className='rounded-circle' id="bring-to-front" title="Bring to Front"><i className="icon-fast-backward rotate" style={{height:"17px"}}></i></button>
//     <button className='rounded-circle' id="send-to-back" title="Send to Back"><i className="icon-fast-forward rotate" style={{height:"17px"}}></i></button>
//     <button className='rounded-circle'id="flip" type="button"  title="Show Back View" onClick={()=>{if(props.designer.showFrontView){props.setFrontCanvasJson(JSON.stringify(props.designer.drawingCanvas));props.designer.drawingCanvas.loadFromJson(props.designer.back)}else{props.setBackCanvasJson(JSON.stringify(props.designer.drawingCanvas))};props.onFlipImageClicked();}}><i className="icon-retweet" style={{height:"17px"}}></i></button>
//     <button className='rounded-circle' id="remove-selected" title="Delete selected item"><i className="icon-trash" style={{height:"17px"}}></i></button>
// </div>
// <button id="mobileZoomButton"onClick={()=>onZoomClicked()} style={{visibility:"hidden"}} className='rounded-circle'  title="Delete selected item"><CgArrowsHAlt size={20} /></button>

// </div> );
// }
 
// export default ImageEditor;